// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Z1Ebk","content":"style_content__NOAjU","saveButton":"style_saveButton__ZpGTV"};